import { Alert, Flex, Group, Switch, Tabs, Text } from "@mantine/core";
import { IIssueBoardApi } from "@schemas/issueBoardSchema";
import React from "react";
import { AccessView } from "../../../components/AccessComp/AccessComp";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import IssueBoardSelector from "./IssueBoardSelector";
import { setUseMantineModalInRedux } from "./issueSlice";
import { getIssueRegisterNameOption } from "./issueUtils";

const IssueTabs: React.FC<{
  activeTab: string;
  setActiveTab: any;
  activeBoard: IIssueBoardApi;
}> = ({ activeTab, setActiveTab, activeBoard }) => {
  const dispatch = useAppDispatch();
  const useMantineModal = useAppSelector((state) => state.issueReducerNew.useMantineModal);
  const useLegacyIssueDialog = !useMantineModal;

  return (
    <Group
      justify="space-between"
      align="end"
      pt="xs"
      mx="xs"
      wrap="nowrap"
      style={{ boxShadow: "inset 0 -2px 0 0 #e4e7eb" }}
    >
      <Tabs value={activeTab} onChange={(v) => setActiveTab(v ?? "issues")} styles={{ tab: { fontWeight: 600 } }}>
        <Tabs.List>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="issues">
            {getIssueRegisterNameOption(activeBoard?.issueNameSetting, "register")}
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="settings">
            <i className="fa fa-cog fa-fw text-black-50" /> Innstillinger
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="logs">
            <i className="fa fa-book fa-fw text-black-50" /> Historikk
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Flex justify="center" align="center" gap="xs" mb="xs">
        <Alert color="lightgray" variant="light" p={"xxs"} px={"xs"}>
          <Text c="blue">Slå på gammel saksdialog</Text>
        </Alert>
        <Switch
          onChange={(event) => dispatch(setUseMantineModalInRedux(!event.currentTarget.checked))}
          checked={useLegacyIssueDialog}
        />
      </Flex>
      <Group gap="sm" wrap="nowrap" pb={"xs"}>
        <AccessView access={activeBoard.access as any} variant="md" />
        <IssueBoardSelector />
      </Group>
    </Group>
  );
};

export default IssueTabs;
